import { Item, ItemActions, ItemDescription, ItemHeader, ItemTitle } from '@ibsys/kit';
import { ReactNode } from 'react';
import { cn } from '@/shared/lib';

type NestedItemCardProps<T> = {
  item: T;
  renderTitle: (item: T) => ReactNode;
  renderDescription?: (item: T) => ReactNode;
  action?: ReactNode;
  className?: string;
};

export const NestedItemCard = <T,>({
  item,
  renderTitle,
  renderDescription,
  action,
  className,
}: NestedItemCardProps<T>) => {
  return (
    <Item variant="outline" className={cn(className)} size={'sm'}>
      <ItemHeader>
        <ItemTitle>{renderTitle(item)}</ItemTitle>
        {action && <ItemActions className="ml-4">{action}</ItemActions>}
      </ItemHeader>
      {renderDescription && (
        <ItemDescription className="text-sm text-muted-foreground line-clamp-1">
          {renderDescription(item)}
        </ItemDescription>
      )}
    </Item>
  );
};
